// extracted by mini-css-extract-plugin
module.exports = {"head":"Categories_head__25ktu","title":"Categories_title__MHI0j","wrapper":"Categories_wrapper__280_I"};